/* eslint-disable max-lines */
import AD from '@shared/public/img/flags/ad.svg';
import AE from '@shared/public/img/flags/ae.svg';
import AF from '@shared/public/img/flags/af.svg';
import AG from '@shared/public/img/flags/ag.svg';
import AI from '@shared/public/img/flags/ai.svg';
import AL from '@shared/public/img/flags/al.svg';
import AM from '@shared/public/img/flags/am.svg';
import AO from '@shared/public/img/flags/ao.svg';
import AQ from '@shared/public/img/flags/aq.svg';
import AR from '@shared/public/img/flags/ar.svg';
import AS from '@shared/public/img/flags/as.svg';
import AT from '@shared/public/img/flags/at.svg';
import AU from '@shared/public/img/flags/au.svg';
import AW from '@shared/public/img/flags/aw.svg';
import AX from '@shared/public/img/flags/ax.svg';
import AZ from '@shared/public/img/flags/az.svg';
import BA from '@shared/public/img/flags/ba.svg';
import BB from '@shared/public/img/flags/bb.svg';
import BD from '@shared/public/img/flags/bd.svg';
import BE from '@shared/public/img/flags/be.svg';
import BF from '@shared/public/img/flags/bf.svg';
import BG from '@shared/public/img/flags/bg.svg';
import BH from '@shared/public/img/flags/bh.svg';
import BI from '@shared/public/img/flags/bi.svg';
import BJ from '@shared/public/img/flags/bj.svg';
import BL from '@shared/public/img/flags/bl.svg';
import BM from '@shared/public/img/flags/bm.svg';
import BN from '@shared/public/img/flags/bn.svg';
import BO from '@shared/public/img/flags/bo.svg';
import BQ from '@shared/public/img/flags/bq.svg';
import BR from '@shared/public/img/flags/br.svg';
import BS from '@shared/public/img/flags/bs.svg';
import BT from '@shared/public/img/flags/bt.svg';
import BV from '@shared/public/img/flags/bv.svg';
import BW from '@shared/public/img/flags/bw.svg';
import BY from '@shared/public/img/flags/by.svg';
import BZ from '@shared/public/img/flags/bz.svg';
import CA from '@shared/public/img/flags/ca.svg';
import CC from '@shared/public/img/flags/cc.svg';
import CD from '@shared/public/img/flags/cd.svg';
import CF from '@shared/public/img/flags/cf.svg';
import CG from '@shared/public/img/flags/cg.svg';
import CH from '@shared/public/img/flags/ch.svg';
import CI from '@shared/public/img/flags/ci.svg';
import CK from '@shared/public/img/flags/ck.svg';
import CL from '@shared/public/img/flags/cl.svg';
import CM from '@shared/public/img/flags/cm.svg';
import CN from '@shared/public/img/flags/cn.svg';
import CO from '@shared/public/img/flags/co.svg';
import CR from '@shared/public/img/flags/cr.svg';
import CU from '@shared/public/img/flags/cu.svg';
import CV from '@shared/public/img/flags/cv.svg';
import CW from '@shared/public/img/flags/cw.svg';
import CX from '@shared/public/img/flags/cx.svg';
import CY from '@shared/public/img/flags/cy.svg';
import CZ from '@shared/public/img/flags/cz.svg';
import DE from '@shared/public/img/flags/de.svg';
import DJ from '@shared/public/img/flags/dj.svg';
import DK from '@shared/public/img/flags/dk.svg';
import DM from '@shared/public/img/flags/dm.svg';
import DO from '@shared/public/img/flags/do.svg';
import DZ from '@shared/public/img/flags/dz.svg';
import EC from '@shared/public/img/flags/ec.svg';
import EE from '@shared/public/img/flags/ee.svg';
import EG from '@shared/public/img/flags/eg.svg';
import EH from '@shared/public/img/flags/eh.svg';
import ER from '@shared/public/img/flags/er.svg';
import ES from '@shared/public/img/flags/es.svg';
import ET from '@shared/public/img/flags/et.svg';
import EU from '@shared/public/img/flags/eu.svg';
import FI from '@shared/public/img/flags/fi.svg';
import FJ from '@shared/public/img/flags/fj.svg';
import FK from '@shared/public/img/flags/fk.svg';
import FM from '@shared/public/img/flags/fm.svg';
import FO from '@shared/public/img/flags/fo.svg';
import FR from '@shared/public/img/flags/fr.svg';
import GA from '@shared/public/img/flags/ga.svg';
import GB_ENG from '@shared/public/img/flags/gb-eng.svg';
import GB_SCT from '@shared/public/img/flags/gb-sct.svg';
import GB_WLS from '@shared/public/img/flags/gb-wls.svg';
import GB from '@shared/public/img/flags/gb.svg';
import GD from '@shared/public/img/flags/gd.svg';
import GE from '@shared/public/img/flags/ge.svg';
import GF from '@shared/public/img/flags/gf.svg';
import GG from '@shared/public/img/flags/gg.svg';
import GH from '@shared/public/img/flags/gh.svg';
import GI from '@shared/public/img/flags/gi.svg';
import GL from '@shared/public/img/flags/gl.svg';
import GM from '@shared/public/img/flags/gm.svg';
import GN from '@shared/public/img/flags/gn.svg';
import GP from '@shared/public/img/flags/gp.svg';
import GQ from '@shared/public/img/flags/gq.svg';
import GR from '@shared/public/img/flags/gr.svg';
import GS from '@shared/public/img/flags/gs.svg';
import GT from '@shared/public/img/flags/gt.svg';
import GU from '@shared/public/img/flags/gu.svg';
import GW from '@shared/public/img/flags/gw.svg';
import GY from '@shared/public/img/flags/gy.svg';
import HK from '@shared/public/img/flags/hk.svg';
import HM from '@shared/public/img/flags/hm.svg';
import HN from '@shared/public/img/flags/hn.svg';
import HR from '@shared/public/img/flags/hr.svg';
import HT from '@shared/public/img/flags/ht.svg';
import HU from '@shared/public/img/flags/hu.svg';
import ID from '@shared/public/img/flags/id.svg';
import IE from '@shared/public/img/flags/ie.svg';
import IL from '@shared/public/img/flags/il.svg';
import IM from '@shared/public/img/flags/im.svg';
import IN from '@shared/public/img/flags/in.svg';
import IO from '@shared/public/img/flags/io.svg';
import IQ from '@shared/public/img/flags/iq.svg';
import IR from '@shared/public/img/flags/ir.svg';
import IS from '@shared/public/img/flags/is.svg';
import IT from '@shared/public/img/flags/it.svg';
import JE from '@shared/public/img/flags/je.svg';
import JM from '@shared/public/img/flags/jm.svg';
import JO from '@shared/public/img/flags/jo.svg';
import JP from '@shared/public/img/flags/jp.svg';
import KE from '@shared/public/img/flags/ke.svg';
import KG from '@shared/public/img/flags/kg.svg';
import KH from '@shared/public/img/flags/kh.svg';
import KI from '@shared/public/img/flags/ki.svg';
import KM from '@shared/public/img/flags/km.svg';
import KN from '@shared/public/img/flags/kn.svg';
import KP from '@shared/public/img/flags/kp.svg';
import KR from '@shared/public/img/flags/kr.svg';
import KW from '@shared/public/img/flags/kw.svg';
import KY from '@shared/public/img/flags/ky.svg';
import KZ from '@shared/public/img/flags/kz.svg';
import LA from '@shared/public/img/flags/la.svg';
import LB from '@shared/public/img/flags/lb.svg';
import LC from '@shared/public/img/flags/lc.svg';
import LI from '@shared/public/img/flags/li.svg';
import LK from '@shared/public/img/flags/lk.svg';
import LR from '@shared/public/img/flags/lr.svg';
import LS from '@shared/public/img/flags/ls.svg';
import LT from '@shared/public/img/flags/lt.svg';
import LU from '@shared/public/img/flags/lu.svg';
import LV from '@shared/public/img/flags/lv.svg';
import LY from '@shared/public/img/flags/ly.svg';
import MA from '@shared/public/img/flags/ma.svg';
import MC from '@shared/public/img/flags/mc.svg';
import MD from '@shared/public/img/flags/md.svg';
import ME from '@shared/public/img/flags/me.svg';
import MF from '@shared/public/img/flags/mf.svg';
import MG from '@shared/public/img/flags/mg.svg';
import MH from '@shared/public/img/flags/mh.svg';
import MK from '@shared/public/img/flags/mk.svg';
import ML from '@shared/public/img/flags/ml.svg';
import MM from '@shared/public/img/flags/mm.svg';
import MN from '@shared/public/img/flags/mn.svg';
import MO from '@shared/public/img/flags/mo.svg';
import MP from '@shared/public/img/flags/mp.svg';
import MQ from '@shared/public/img/flags/mq.svg';
import MR from '@shared/public/img/flags/mr.svg';
import MS from '@shared/public/img/flags/ms.svg';
import MT from '@shared/public/img/flags/mt.svg';
import MU from '@shared/public/img/flags/mu.svg';
import MV from '@shared/public/img/flags/mv.svg';
import MW from '@shared/public/img/flags/mw.svg';
import MX from '@shared/public/img/flags/mx.svg';
import MY from '@shared/public/img/flags/my.svg';
import MZ from '@shared/public/img/flags/mz.svg';
import NA from '@shared/public/img/flags/na.svg';
import NC from '@shared/public/img/flags/nc.svg';
import NE from '@shared/public/img/flags/ne.svg';
import NF from '@shared/public/img/flags/nf.svg';
import NG from '@shared/public/img/flags/ng.svg';
import NI from '@shared/public/img/flags/ni.svg';
import NL from '@shared/public/img/flags/nl.svg';
import NO from '@shared/public/img/flags/no.svg';
import NP from '@shared/public/img/flags/np.svg';
import NR from '@shared/public/img/flags/nr.svg';
import NU from '@shared/public/img/flags/nu.svg';
import NZ from '@shared/public/img/flags/nz.svg';
import OM from '@shared/public/img/flags/om.svg';
import PA from '@shared/public/img/flags/pa.svg';
import PE from '@shared/public/img/flags/pe.svg';
import PF from '@shared/public/img/flags/pf.svg';
import PG from '@shared/public/img/flags/pg.svg';
import PH from '@shared/public/img/flags/ph.svg';
import PK from '@shared/public/img/flags/pk.svg';
import PL from '@shared/public/img/flags/pl.svg';
import PM from '@shared/public/img/flags/pm.svg';
import PN from '@shared/public/img/flags/pn.svg';
import PR from '@shared/public/img/flags/pr.svg';
import PS from '@shared/public/img/flags/ps.svg';
import PT from '@shared/public/img/flags/pt.svg';
import PW from '@shared/public/img/flags/pw.svg';
import PY from '@shared/public/img/flags/py.svg';
import QA from '@shared/public/img/flags/qa.svg';
import RE from '@shared/public/img/flags/re.svg';
import RO from '@shared/public/img/flags/ro.svg';
import RS from '@shared/public/img/flags/rs.svg';
import RU from '@shared/public/img/flags/ru.svg';
import RW from '@shared/public/img/flags/rw.svg';
import SA from '@shared/public/img/flags/sa.svg';
import SB from '@shared/public/img/flags/sb.svg';
import SC from '@shared/public/img/flags/sc.svg';
import SD from '@shared/public/img/flags/sd.svg';
import SE from '@shared/public/img/flags/se.svg';
import SG from '@shared/public/img/flags/sg.svg';
import SH from '@shared/public/img/flags/sh.svg';
import SI from '@shared/public/img/flags/si.svg';
import SJ from '@shared/public/img/flags/sj.svg';
import SK from '@shared/public/img/flags/sk.svg';
import SL from '@shared/public/img/flags/sl.svg';
import SM from '@shared/public/img/flags/sm.svg';
import SN from '@shared/public/img/flags/sn.svg';
import SO from '@shared/public/img/flags/so.svg';
import SR from '@shared/public/img/flags/sr.svg';
import SS from '@shared/public/img/flags/ss.svg';
import ST from '@shared/public/img/flags/st.svg';
import SV from '@shared/public/img/flags/sv.svg';
import SX from '@shared/public/img/flags/sx.svg';
import SY from '@shared/public/img/flags/sy.svg';
import SZ from '@shared/public/img/flags/sz.svg';
import TC from '@shared/public/img/flags/tc.svg';
import TD from '@shared/public/img/flags/td.svg';
import TF from '@shared/public/img/flags/tf.svg';
import TG from '@shared/public/img/flags/tg.svg';
import TH from '@shared/public/img/flags/th.svg';
import TJ from '@shared/public/img/flags/tj.svg';
import TK from '@shared/public/img/flags/tk.svg';
import TL from '@shared/public/img/flags/tl.svg';
import TM from '@shared/public/img/flags/tm.svg';
import TN from '@shared/public/img/flags/tn.svg';
import TO from '@shared/public/img/flags/to.svg';
import TR from '@shared/public/img/flags/tr.svg';
import TT from '@shared/public/img/flags/tt.svg';
import TV from '@shared/public/img/flags/tv.svg';
import TW from '@shared/public/img/flags/tw.svg';
import TZ from '@shared/public/img/flags/tz.svg';
import UA from '@shared/public/img/flags/ua.svg';
import UG from '@shared/public/img/flags/ug.svg';
import UM from '@shared/public/img/flags/um.svg';
import UN from '@shared/public/img/flags/un.svg';
import US from '@shared/public/img/flags/us.svg';
import UY from '@shared/public/img/flags/uy.svg';
import UZ from '@shared/public/img/flags/uz.svg';
import VA from '@shared/public/img/flags/va.svg';
import VC from '@shared/public/img/flags/vc.svg';
import VE from '@shared/public/img/flags/ve.svg';
import VG from '@shared/public/img/flags/vg.svg';
import VI from '@shared/public/img/flags/vi.svg';
import VN from '@shared/public/img/flags/vn.svg';
import VU from '@shared/public/img/flags/vu.svg';
import WF from '@shared/public/img/flags/wf.svg';
import WS from '@shared/public/img/flags/ws.svg';
import XK from '@shared/public/img/flags/xk.svg';
import YE from '@shared/public/img/flags/ye.svg';
import YT from '@shared/public/img/flags/yt.svg';
import ZA from '@shared/public/img/flags/za.svg';
import ZM from '@shared/public/img/flags/zm.svg';
import ZW from '@shared/public/img/flags/zw.svg';
import ZZ from '@shared/public/img/flags/zz.svg';

const flags: { [key: string]: string } = {
    AD,
    AE,
    AF,
    AG,
    AI,
    AL,
    AM,
    AO,
    AQ,
    AR,
    AS,
    AT,
    AU,
    AW,
    AX,
    AZ,
    BA,
    BB,
    BD,
    BE,
    BF,
    BG,
    BH,
    BI,
    BJ,
    BL,
    BM,
    BN,
    BO,
    BQ,
    BR,
    BS,
    BT,
    BV,
    BW,
    BY,
    BZ,
    CA,
    CC,
    CD,
    CF,
    CG,
    CH,
    CI,
    CK,
    CL,
    CM,
    CN,
    CO,
    CR,
    CU,
    CV,
    CW,
    CX,
    CY,
    CZ,
    DE,
    DJ,
    DK,
    DM,
    DO,
    DZ,
    EC,
    EE,
    EG,
    EH,
    ER,
    ES,
    ET,
    EU,
    FI,
    FJ,
    FK,
    FM,
    FO,
    FR,
    GA,
    'GB-ENG': GB_ENG,
    'GB-SCT': GB_SCT,
    'GB-WLS': GB_WLS,
    GB,
    GD,
    GE,
    GF,
    GG,
    GH,
    GI,
    GL,
    GM,
    GN,
    GP,
    GQ,
    GR,
    GS,
    GT,
    GU,
    GW,
    GY,
    HK,
    HM,
    HN,
    HR,
    HT,
    HU,
    ID,
    IE,
    IL,
    IM,
    IN,
    IO,
    IQ,
    IR,
    IS,
    IT,
    JE,
    JM,
    JO,
    JP,
    KE,
    KG,
    KH,
    KI,
    KM,
    KN,
    KP,
    KR,
    KW,
    KY,
    KZ,
    LA,
    LB,
    LC,
    LI,
    LK,
    LR,
    LS,
    LT,
    LU,
    LV,
    LY,
    MA,
    MC,
    MD,
    ME,
    MF,
    MG,
    MH,
    MK,
    ML,
    MM,
    MN,
    MO,
    MP,
    MQ,
    MR,
    MS,
    MT,
    MU,
    MV,
    MW,
    MX,
    MY,
    MZ,
    NA,
    NC,
    NE,
    NF,
    NG,
    NI,
    NL,
    NO,
    NP,
    NR,
    NU,
    NZ,
    OM,
    PA,
    PE,
    PF,
    PG,
    PH,
    PK,
    PL,
    PM,
    PN,
    PR,
    PS,
    PT,
    PW,
    PY,
    QA,
    RE,
    RO,
    RS,
    RU,
    RW,
    SA,
    SB,
    SC,
    SD,
    SE,
    SG,
    SH,
    SI,
    SJ,
    SK,
    SL,
    SM,
    SN,
    SO,
    SR,
    SS,
    ST,
    SV,
    SX,
    SY,
    SZ,
    TC,
    TD,
    TF,
    TG,
    TH,
    TJ,
    TK,
    TL,
    TM,
    TN,
    TO,
    TR,
    TT,
    TV,
    TW,
    TZ,
    UA,
    UG,
    UM,
    UN,
    US,
    UY,
    UZ,
    VA,
    VC,
    VE,
    VG,
    VI,
    VN,
    VU,
    WF,
    WS,
    XK,
    YE,
    YT,
    ZA,
    ZM,
    ZW,
    ZZ,
};

export const INLINE_FALLBACK_TRANSPARENT_IMAGE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAFoEvQfAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAAaADAAQAAAABAAAAAQAAAAD5Ip3+AAAAC0lEQVQIHWNgAAIAAAUAAY27m/MAAAAASUVORK5CYII=';

const LANGUAGE_COUNTRY_MAP: { [key: string]: string } = {
    en: 'GB',
    de: 'AT',
    cs: 'CZ',
    sr: 'RS',
};

const COUNTRY_ABBREVIATION_LENGTH = 2;

export function getFlagDataUrl(countryCode: string): string {
    return flags[countryCode] ?? INLINE_FALLBACK_TRANSPARENT_IMAGE;
}

function getCountryAbbreviation(currency: string): string {
    return currency.toLocaleLowerCase().substring(0, COUNTRY_ABBREVIATION_LENGTH).toUpperCase();
}

export function getFlagDataUrlForCurrency(currency: string): string {
    return getFlagDataUrl(getCountryAbbreviation(currency));
}

function getLanguageCountryCode(language: string): string {
    return LANGUAGE_COUNTRY_MAP[language] ?? language.toUpperCase();
}

export function getLanguageFlagDataUrl(language: string): string {
    return getFlagDataUrl(getLanguageCountryCode(language));
}
